import ApiService from "@/common/api.service"

export const TrainerService = {
    create(params) {
        return ApiService.post("Trainers/add", params);
    },
    update(slug, params) {
        return ApiService.update("/Trainers", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("/Trainers/delete", slug, params)
    },
    async getTrainers() {
        const resp = await ApiService.get("/Trainers");
        return resp.data.rows;
    },
    async getTrainersWP(page, itemsPerPage, name) {
        const resp = await ApiService.get(
            `/Trainers?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return resp.data;
    },
    completeTrainerCourse(param) {
        return ApiService.put("/trainers/course/completeCourse", param);
    },
    generateQrCode(params) {
        return ApiService.post("/generateQrCode/scan", params);
    },
    async getImage(params) {
        const res = await ApiService.post("/getImageRequest/logo", params);
        return res;
    },
    async getTrainer(slug) {
        const resp = await ApiService.get("/Trainers/" + slug);
        return resp;
    },
    async getPublicTrainerInfo(slug1, slug2, slug3) {
        const resp = await ApiService.get("/Trainers/public/" + slug1 + "/" + slug2 + "/" + slug3);
        return resp.data;
    },

}